import { fetchPostingsByEstateIdThunk } from "../../postings/postingList/postingListActions";
import { fetchPropertyManagementThunk } from "../../propertyManagement/propertyManagementSlice";

import { fetchEstateByIdAsync } from "../estateApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setCurrentEstateByIdThunk = createAsyncThunk(
  "estates/currentEstate/fetchById",
  async (estateId, { dispatch, rejectWithValue }) => {
    try {
      const estateResponse = await fetchEstateByIdAsync(estateId);

      if (estateResponse.status === 200) {
        const { data: estate } = estateResponse;

        // dispatch follow-up actions
        dispatch(fetchPostingsByEstateIdThunk(estate.id));

        try {
          // fetch property management if present
          if (estate.propertyManagementId) {
            dispatch(fetchPropertyManagementThunk(estate.propertyManagementId));
          }
        } catch (err) {
          console.error(
            "Problems while fetching current property management in estate action.",
            err,
          );
        }

        return estate;
      }

      return rejectWithValue(estateResponse);
    } catch (err) {
      console.error("Problems while fetching current estate.", err);
      return rejectWithValue(err);
    }
  },
);

const slice = createSlice({
  name: "currentEstate",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCurrentEstateByIdThunk.pending, (state) => ({
      ...state,
      isLoading: true,
    }));
    builder.addCase(setCurrentEstateByIdThunk.fulfilled, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
    }));
    builder.addCase(setCurrentEstateByIdThunk.rejected, (state) => ({
      ...state,
      isLoading: false,
    }));
  },
});

const selectSelf = (state) => state.estates.currentEstate;
const selectCurrentEstate = (state) => selectSelf(state);

export const currentEstateSelectors = { selectCurrentEstate };

export const reducer = slice.reducer;
